var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "addContextMenu",
    },
    [
      _c("a-card", { staticClass: "search-results-card" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "justify-content": "center",
              padding: "10px 30px",
            },
          },
          [
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "justify-content": "end",
                  "text-align": "center",
                  "align-items": "center",
                },
              },
              [
                _c("a-icon", {
                  staticStyle: { "font-size": "23px !important" },
                  attrs: { type: "search" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              ref: "focusMe",
              staticStyle: { padding: "0 10px" },
              attrs: {
                id: "context-search",
                type: "search",
                placeholder: _vm.$t("chatbotv2.search"),
              },
              domProps: { value: _vm.query },
              on: {
                keypress: function ($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
                    return null
                  }
                  return _vm.focusAndNavigate(_vm.selectedIndex)
                },
                keyup: function ($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 40) {
                    return null
                  }
                  return _vm.inputArrowDown()
                },
                keydown: function ($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 38) {
                    return null
                  }
                  return _vm.inputArrowUp()
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.query = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "justify-content": "end",
                  "text-align": "center",
                  "align-items": "center",
                },
              },
              [
                _vm.bar !== 0
                  ? _c("a-icon", {
                      staticStyle: { "font-size": "21px" },
                      attrs: { type: "close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close-menu", 0)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _vm.query.length > 2
          ? _c(
              "div",
              { staticClass: "searching-results" },
              _vm._l(_vm.resultList, function (action, i) {
                return _c(
                  "button",
                  {
                    staticClass: "search-results-btn",
                    class: { selected: i === _vm.selectedIndex },
                    attrs: {
                      autofocus: i === _vm.selectedIndex,
                      id: "search-results-btn-id" + i,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectByClick(action)
                      },
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          $event.keyCode !== 13
                        ) {
                          return null
                        }
                        return _vm.focusAndNavigate(_vm.selectedIndex)
                      },
                      mouseover: function ($event) {
                        return _vm.onlyFocusOn(action)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "search-results-btn-child" },
                      [
                        _c("BlockIconPreview", {
                          staticClass: "block-icon-preview-search",
                          attrs: { "block-type": action.type },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                              "text-align": "start",
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("chatbotv2." + action.type)) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: { "font-weight": "700" },
                                attrs: { id: "block-name-id" + i },
                              },
                              [_vm._v(_vm._s(action.name))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            )
          : _vm.query.length > 0
          ? _c(
              "div",
              {
                staticClass: "searching-results",
                staticStyle: { background: "#e8eef3" },
              },
              [
                _c("div", { staticClass: "search-results-less-char" }, [
                  _c(
                    "p",
                    {
                      staticClass: "search-results-btn-child",
                      staticStyle: { color: "#516173" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.typeMoreThan3Char")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.query.length > 2 && _vm.resultList.length <= 0
          ? _c(
              "div",
              {
                staticClass: "searching-results",
                staticStyle: { background: "#e8eef3" },
              },
              [
                _c("div", { staticClass: "search-results-less-char" }, [
                  _c(
                    "p",
                    {
                      staticClass: "search-results-btn-child",
                      staticStyle: { color: "#516173" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chatbotv2.noMatchingItem")))]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.query.length > 2 && _vm.resultList.length > 0
        ? _c("a-card", { staticClass: "hint-footer" }, [
            _c(
              "div",
              {
                staticClass: "hint-content",
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "justify-content": "center",
                  "align-items": "center",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "5px",
                      "padding-right": "10px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("chatbotv2.hint")) + ":")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "5px",
                      "padding-right": "10px",
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "arrow-up" } }),
                    _c("a-icon", { attrs: { type: "arrow-down" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("chatbotv2.navigate")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "5px",
                      "padding-right": "10px",
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "enter" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("chatbotv2.select")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "5px",
                      "padding-right": "10px",
                    },
                  },
                  [_vm._v("ESC " + _vm._s(_vm.$t("chatbotv2.dismiss")))]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }